import { useCallback } from "react"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { useJourney } from "#/components/carrot-plans/hooks/useJourney"

export function useTrackCollectiveItemAction(internalName?: string, headline?: string, offerCopy?: string) {
  const { mutate: addMemberAction } = useMemberActionTracking()
  const { resolvedJourney } = useJourney()

  return useCallback(
    (memberActionTaken: MemberActions) => {
      const payload = {
        memberActionTaken,
        metaData: {
          memberJourney: resolvedJourney,
          collectiveItem: {
            internalName,
            headline,
            offerCopy
          }
        }
      }
      addMemberAction(payload)
    },
    [addMemberAction, resolvedJourney, internalName, headline, offerCopy]
  )
}
